/**
 * Generates a status icon
 *
 * @param   {boolean}  iconName
 * @return  {string}
 */
export const generateStatusIconHTML = (publishedAt = false) => {
  const isPublished = moment().isSameOrAfter(publishedAt)
  const status = isPublished ? 'published-entry' : 'draft-entry'
  return `<i class="fa fa-circle photonTreeIcon ${status}"></i>`
}
